class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Mouse/trackpad only: close submenu as soon as pointer leaves (no need to click again)
    this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    this.closeDelay = 150;
    this.closeTimer = null;
    this.cancelScheduledClose = () => {
      if (this.closeTimer) window.clearTimeout(this.closeTimer);
      this.closeTimer = null;
    };
    this.scheduleClose = () => {
      this.cancelScheduledClose();
      this.closeTimer = window.setTimeout(() => this.close(), this.closeDelay);
    };
    this.onMouseLeave = () => this.close();
    this.onPointerMove = (event) => {
      if (!this.mainDetailsToggle?.open) return;
      if (!this.contains(event.target)) {
        this.scheduleClose();
      } else {
        this.cancelScheduledClose();
      }
    };

    if (this.canHover && this.mainDetailsToggle) {
      // Attach to <details> for reliable hitbox behavior
      this.onMouseLeave = () => this.scheduleClose();
      this.onMouseEnter = () => this.cancelScheduledClose();
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter);
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );

    if (this.canHover) {
      if (this.mainDetailsToggle.open) {
        window.addEventListener('pointermove', this.onPointerMove, true);
      } else {
        window.removeEventListener('pointermove', this.onPointerMove, true);
      }
    }
  }

  close() {
    super.close();
    this.cancelScheduledClose?.();
    if (this.canHover) window.removeEventListener('pointermove', this.onPointerMove, true);
  }

  disconnectedCallback() {
    if (this.canHover && this.mainDetailsToggle) {
      this.mainDetailsToggle.removeEventListener('mouseleave', this.onMouseLeave);
      this.mainDetailsToggle.removeEventListener('mouseenter', this.onMouseEnter);
      window.removeEventListener('pointermove', this.onPointerMove, true);
    }
  }
}

customElements.define('header-menu', HeaderMenu);
